export const mapTypes = {
    satellite:{
        url:'http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga',
        ref_name:'Google Satellite'
    },
    street:{
          url:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        ref_name:'OpenStreetMap'
    },
    terrain:{
        url:'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
        ref_name:'opentopomap' 
    },
    cartoDBLight:{
        url:'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}@2x.png',
        ref_name:'CartoDB' 
    }
}